import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Form, Control, Errors } from "react-redux-form";
import _ from "lodash";
import {isRequired, maxLength, isEmail, email, phoneNumber, isCurp, isRfc} from "../field_validations";
import {allLower, allUpper} from "../parsers";
import DatePick from './../forms/datepicker';
import GreetingsSelect from "../forms/greeting_select";
import BigFileUpload from "../widgets/big_file_upload";

const propTypes = {
	owner: PropTypes.object.isRequired,
	permissions: PropTypes.array.isRequired,
	//loadFormData: PropTypes.func.isRequired,
	saveOwner: PropTypes.func.isRequired,
	//revision: PropTypes.object
}

class RegisterEditForm extends Component {
	render() {
		const { owner, permissions, modalities, match } = this.props;
		let ownerRev = owner.revision ? owner.revision.body : undefined;
		let modality = _.find(modalities.list, {slug: match.params.modality});
		let pc = _.find(permissions, (o) => {return o==='Create'});
		return (
			<div className="columns">
					<div className="column">
						<Form model="project.owner.data" onSubmit={(project) => this.handleSubmit(project)} onSubmitFailed={(error) => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario.', 'danger')}>
							<div className="field is-grouped">
								<div className="control">
									<label htmlFor="title" className="label">Saludo <span className="small has-text-danger">*</span></label>
									<div className={`select${owner.isFetching ? ' is-loading' : ''}${ownerRev ? ' is-'+ownerRev.status : ''}`}>
										<Control model=".title" id="title" component={GreetingsSelect} validateOn="change" errors={{isRequired}} disabled={this._blockField()} />
									</div>
									<Errors model=".title" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Debes elegir un saludo'}} />
								</div>

								<div className={`control is-expanded${owner.isFetching ? ' is-loading' : ''}`}>
									<label htmlFor="name" className="label">Nombre(s) <span className="small has-text-danger">*</span></label>
									<Control.text model=".name" className={`input${ownerRev ? ' is-'+ownerRev.status : ''}`} id="name" errors={{isRequired}} placeholder="Nombre(s)" validateOn="change" disabled={this._blockField()} />
									<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
								</div>

								<div className={`control is-expanded${owner.isFetching ? ' is-loading' : ''}`}>
									<label htmlFor="last_name" className="label">Primer apellido <span className="small has-text-danger">*</span></label>
									<Control.text model=".last_name" className={`input${ownerRev ? ' is-'+ownerRev.status : ''}`} id="last_name" errors={{isRequired}} validateOn="change" disabled={this._blockField()} />
									<Errors model=".last_name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El apellido es obligatorio'}} />
								</div>

								<div className={`control is-expanded${owner.isFetching ? ' is-loading' : ''}`}>
									<label htmlFor="slast_name" className="label">Segundo apellido</label>
									<Control.text model=".slast_name" className={`input${ownerRev ? ' is-'+ownerRev.status : ''}`} id="slast_name" disabled={this._blockField()} />
								</div>
							</div>

							<div className="field is-grouped">
								<div className="control">
									<label htmlFor="sex" className="label">Sexo <span className="small has-text-danger">*</span></label>
									<div className={`select${owner.isFetching ? ' is-loading' : ''}${ownerRev ? ' is-'+ownerRev.status : ''}`}>
										<Control.select model=".sex" id="sex" errors={{isRequired}} validateOn="change" disabled={this._blockField()}>
											<option value="" defaultValue>--- Sexo ---</option>
											<option value="M">Mujer</option>
											<option value="H">Hombre</option>
										</Control.select>
									</div>
									<Errors model=".sex" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El sexo es obligatorio'}} />
								</div>
								<div className={`control is-expanded${owner.isFetching ? ' is-loading' : ''}`}>
									<label htmlFor="rfc" className="label">RFC <span className="small has-text-danger">*</span></label>
									<Control.text model=".rfc" id="rfc" className={`input${ownerRev ? ' is-'+ownerRev.status : ''}`} placeholder="RFC" errors={{isRequired, isRfc}} validateOn="change" parser={ allUpper } disabled={this._blockField()} />
									<Errors model=".rfc" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El RFC es obligatorio. ', isRfc: 'RFC inválido. '}} />
								</div>
								<div className={`control is-expanded${owner.isFetching ? ' is-loading' : ''}`}>
									<label htmlFor="curp" className="label">CURP <span className="small has-text-danger">*</span></label>
									<Control.text model=".curp" id="curp" className={`input${ownerRev ? ' is-'+ownerRev.status : ''}`} placeholder="CURP" errors={{isRequired, maxLength: maxLength(18), isCurp}} validateOn="change" parser={ allUpper } disabled={this._blockField()} />
									<Errors model=".curp" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'La CURP es obligatoria. ', isCurp: 'CURP inválida. '}} />
								</div>
							</div>

							<div className="field is-grouped">
								<div className={`control is-expanded`}>
									<label htmlFor="scholarship" className="label">Escolaridad <span className="small has-text-danger">*</span></label>
									<Control.text model=".scholarship" id="scholarship" className={`input${ownerRev ? ' is-'+ownerRev.status : ''}`} placeholder="Escolaridad" errors={{isRequired}} disabled={this._blockField()} />
									<Errors model=".scholarship" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'La escolaridad es obligatoria'}} />
								</div>

								<div className={`control${owner.isFetching ? ' is-loading' : ''}`}>
									<label htmlFor="period_start" className="label">Fecha en que asumió cargo <span className="small has-text-danger">*</span></label>
									<Control model=".period_start" id="period_start" value={owner.data && owner.data.period_start ? owner.data.period_start:''} className={`input${ownerRev ? ' is-'+ownerRev.status : ''}`} errors={{isRequired}} component={DatePick} disabled={this._blockField()} />
									<Errors model=".period_start" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'La fecha en la que asumió el cargo es obligatoria. '}} />
								</div>
							</div>

							<div className="field is-grouped">
								<div className={`control is-expanded${owner.isFetching ? ' is-loading' : ''}`}>
									<label htmlFor="email" className="label">Email principal<span className="small has-text-danger">*</span></label>
									<Control.text model=".email" className={`input${ownerRev ? ' is-'+ownerRev.status : ''}`} placeholder="Email principal *" errors={{isRequired, isEmail}} validateOn="change" parser={ allLower } disabled={this._blockField()} />
									<Errors model=".email" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El email es obligatorio', isEmail: 'El email es inválido'}} />
								</div>

								<div className={`control is-expanded${owner.isFetching ? ' is-loading' : ''}`}>
									<label htmlFor="email_2" className="label">Email secundario </label>
									<Control.text model=".email_2" id="email_2" className={`input${ownerRev ? ' is-'+ownerRev.status : ''}`} placeholder="Email secundario" errors={{email}} validateOn="change" parser={ allLower } disabled={this._blockField()} />
									<Errors model=".email_2" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{email: 'El email es inválido'}} />
								</div>
							</div>

							<div className="field is-grouped">
								<div className={`control is-expanded${owner.isFetching ? ' is-loading' : ''}`}>
									<label htmlFor="telephone" className="label">Teléfono principal <span className="small has-text-danger">*</span></label>
									<Control.text model=".telephone" id="telephone" className={`input${ownerRev ? ' is-'+ownerRev.status : ''}`} placeholder="Teléfono principal" errors={{isRequired, phoneNumber}} validateOn="change" disabled={this._blockField()} />
									<Errors model=".telephone" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El Teléfono es obligatorio'}} />
								</div>

								<div className={`control is-expanded${owner.isFetching ? ' is-loading' : ''}`}>
									<label htmlFor="telephone_2" className="label">Teléfono alterno</label>
									<Control.text model=".telephone_2" id="telephone_2" className={`input${ownerRev ? ' is-'+ownerRev.status : ''}`} placeholder="Teléfono alterno" errors={{phoneNumber}} validateOn="change" disabled={this._blockField()} />
									<Errors model=".telephone_2" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{phoneNumber}} />
								</div>
							</div>

							<hr />
							<h4 className="title is-5">Documentación</h4>
							<div className="hero is-light">
								<div className="hero-body">
									<div className="field is-grouped is-grouped-multiline is-grouped-left">
										{_.map(_.filter(owner.documents_items, (o) => {return o.modality_id === null || o.modality_id === (modality ? modality.id:undefined)}),(item, d) => {
											let documentRev =!_.isEmpty(ownerRev) ? _.find(ownerRev, {field: item.slug}):undefined;
											let accepts = undefined;
											_.map(item.documents_types, (ext) => {
												accepts = accepts ? `${accepts},${ext.extensions}`:`${ext.extensions}`
											})
											return (
												<BigFileUpload
													key={d}
													model={`.${item.slug}`}
													name={item.name}
													file={owner.data && owner.data[item.slug]}
													file_format={item.file_format}
													accept={accepts}
													comment={documentRev && documentRev.comment ? documentRev.comment:undefined}
													status={documentRev && documentRev.status}
													disabled={this._blockField()}
												/>
											)
										})}
									</div>
								</div>
							</div>
							<br/>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button type="button" className="button is-large" onClick={() => this.props.history.push('/inicio')}>
										Regresar
									</button>
								</div>

								{pc ?
								<div className="control">
									<Control.button model="project.register" className="button is-large is-primary" disabled={this._blockField()}>
										Guardar
									</Control.button>
								</div>:''}
							</div>

							<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
						</Form>
					</div>
				</div>
		);
	}
	constructor() {
		super();
		this.state = {
			cleanForm: true
		}
	}

	/*componentWillReceiveProps(newprops) {
		if(!newprops.owner.isFetching){
			if(!_.isEmpty(newprops.owner.data) && newprops.owner.data !== this.props.owner.data && this.state.cleanForm) {
				this.props.loadFormData('project.owner.data', newprops.owner.data);
				return this.setState({cleanForm: false});
			}
		}
	}*/

	handleSubmit(values, event) {
		const { params } = this.props.match;
		this.props.saveOwner(params.modality, params.state, params.municipality, values, event);
	}

	_blockField() {
		let { owner } = this.props;
		let response = false;
		let editable = owner.editable;
		let ownerRevision = !_.isEmpty(owner.revision) ? owner.revision.body : undefined;

		if(!_.isEmpty(ownerRevision) && !owner.isFetching){
			let allow = _.find(ownerRevision, {allow_edit: 'true'}) ? true : false;
			if(editable && allow){
				response = false;
			}else{
				response = true;
			}
		}else if(editable && !owner.isFetching){
			response = false;
		}else {
			response = true;
		}

		return response;
	}
}

RegisterEditForm.propTypes = propTypes;

export default RegisterEditForm;


// WEBPACK FOOTER //
// ./src/elements/project/owner.jsx